import { useEffect, useState } from "react"
import { Link, useLocation } from "react-router-dom"
import {
  Button,
  TextField,
  Typography,
  Box,
  Stack,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Grid,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material"
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from "@ionic/react"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { addJobRoles, getJobRolesById } from "../../../Services/BusinessOwner"
import styles from "./JobSetupDetails.module.css"

type Role = Record<string, string | null | undefined>

const JobSetUpProjectDetail = () => {
  const uselocation = useLocation()
  const queryParams = new URLSearchParams(uselocation.search)
  const id = queryParams.get("id")
  // const data = uselocation.state?.["data"] || {
  //   project_name: "Demo Project",
  //   budget_cost: "₦10,000,000",
  //   project: 5,
  //   tags: "Engineering, Remote, Full-time",
  // }
  const data = uselocation.state?.["project"] || null
  console.log("Project data from state:", data)

  // Basic Job Role Info
  const [newJobTitle, setNewJobTitle] = useState("")
  const [newBudget, setNewBudget] = useState("")
  const [newNumberOfPeople, setNewNumberOfPeople] = useState("")
  const [numberApplicant, setNumberApplicant] = useState("")

  // Location & Work Preferences
  const [location, setLocation] = useState("")
  const [willingToRelocate, setWillingToRelocate] = useState("")
  const [remoteWorkPreference, setRemoteWorkPreference] = useState("")
  const [employmentType, setEmploymentType] = useState([])
  const [availability, setAvailability] = useState("")

  // Personal Information
  const [nationality, setNationality] = useState("")
  const [workAuthorization, setWorkAuthorization] = useState("")
  const [minAge, setMinAge] = useState("")
  const [maxAge, setMaxAge] = useState("")
  const [gender, setGender] = useState("")
  const [languagesSpoken, setLanguagesSpoken] = useState("")

  // Education
  const [levelOfEducation, setLevelOfEducation] = useState("")
  const [fieldOfStudy, setFieldOfStudy] = useState("")
  const [certificateQualification, setCertificateQualification] = useState("")

  // Experience & Skills
  const [skills, setSkills] = useState("")
  const [previousIndustries, setPreviousIndustries] = useState("")
  const [totalYearOfExperience, setTotalYearOfExperience] = useState("")
  const [jobFunction, setJobFunction] = useState("")
  const [preferredIndustries, setPreferredIndustries] = useState("")

  // Salary
  const [minSalary, setMinSalary] = useState("")
  const [maxSalary, setMaxSalary] = useState("")

  // const [selectedRole, setSelectedRole] = useState<any | null>(null)
  const [selectedRole, setSelectedRole] = useState<Role | null>(null);
  const [openViewModal, setOpenViewModal] = useState(false)
  const [openAddModal, setOpenAddModal] = useState(false)
  const [customRoles, setCustomRoles] = useState<any[]>([])


  useEffect(() => {
    // Fetch existing job roles if id is provided
    if (id) {
      fetchJobRoles()
    }
  }, [id])

  const fetchJobRoles = async () => {
    try {
      const response = await getJobRolesById(id)
      console.log("Fetched job roles:", response.response)
      if (response.message) {
        setCustomRoles(response.response || [])
      }
    } catch (error) {
      console.error("Error fetching job roles:", error)
    }
  }

  const handleAddNewRole = async () => {
    // Validate required inputs
    if (!newJobTitle || !newBudget || !newNumberOfPeople) {
      alert("Please fill in all required fields (Job Title, Budget, Number of People)")
      return
    }

    const newRole = {
      project_id: id,
      jobrole_id: "JOB-" + Date.now(), // Generate unique ID

      // Basic Info
      job_title: newJobTitle,
      budget: newBudget,
      number_required: newNumberOfPeople,
      // number_required: numberApplicant || 50,

      // Location & Work Preferences
      location: location,
      willing_to_relocate: willingToRelocate,
      remote_work_preference: remoteWorkPreference,
      employment_type: Array.isArray(employmentType) ? employmentType.join(",") : employmentType,
      availability: availability,

      // Personal Information
      nationality: nationality,
      work_authorization: workAuthorization,
      minage: Number.parseInt(minAge) || null,
      maxage: Number.parseInt(maxAge) || null,
      gender: gender,
      languages_spoken: languagesSpoken,

      // Education
      level_of_education: levelOfEducation,
      field_of_study: fieldOfStudy,
      certificate_qualification: certificateQualification,

      // Experience & Skills
      skills: skills,
      previous_industries: previousIndustries,
      total_year_of_experience: Number.parseInt(totalYearOfExperience) || null,
      job_function: jobFunction,
      preferred_industries: preferredIndustries,

      // Salary
      minsalary: Number.parseFloat(minSalary) || null,
      maxsalary: Number.parseFloat(maxSalary) || null,
    }
    console.log("New Job Role Data:", newRole)

    try {
      const response = await addJobRoles(newRole)
      console.log("Add Job Role response:", response)

      // Add new role to custom roles state
      setCustomRoles((prev) => [...prev, newRole])

      // Reset all form fields
      // resetForm()
      setOpenAddModal(false)

      alert("Job role added successfully!")
    } catch (error) {
      console.error("Error adding job role:", error)
      alert("Error adding job role. Please try again.")
    }
  }

  const resetForm = () => {
    setNewJobTitle("")
    setNewBudget("")
    setNewNumberOfPeople("")
    setNumberApplicant("")
    setLocation("")
    setWillingToRelocate("")
    setRemoteWorkPreference("")
    setEmploymentType([])
    setAvailability("")
    setNationality("")
    setWorkAuthorization("")
    setMinAge("")
    setMaxAge("")
    setGender("")
    setLanguagesSpoken("")
    setLevelOfEducation("")
    setFieldOfStudy("")
    setCertificateQualification("")
    setSkills("")
    setPreviousIndustries("")
    setTotalYearOfExperience("")
    setJobFunction("")
    setPreferredIndustries("")
    setMinSalary("")
    setMaxSalary("")
  }


  const handleView = (role: Role) => {
    setSelectedRole(role)
    setOpenViewModal(true)
  }

  const handleEmploymentTypeChange = (event: any) => {
    const value = event.target.value
    setEmploymentType(typeof value === "string" ? value.split(",") : value)
  }

  return (
    <IonPage className={styles.pageContainer}>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>Project Management</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen className={styles.contentWrapper}>
        <div className={styles.headerCard}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
            <Link to="/folder/businessOwnerDashboard" style={{ textDecoration: "none" }}>
              <Button className={styles.backButton} startIcon={<span>←</span>}>
                Back to Projects
              </Button>
            </Link>
          </Stack>

          <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mb: 1 }}>
            Job Role Management
          </Typography>
          <Typography variant="h6" sx={{ opacity: 0.9, fontWeight: 400 }}>
            Configure job roles for {data?.project_name || "your project"}
          </Typography>

          <div className={styles.statsGrid}>
            <div className={styles.statCard}>
              <div className={styles.statNumber}>{customRoles.length}</div>
              <div className={styles.statLabel}>Job Roles</div>
            </div>
            <div className={styles.statCard}>
              <div className={styles.statNumber}>
                {customRoles.reduce((sum, role) => sum + (Number.parseInt(role.number_required) || 0), 0)}
              </div>
              <div className={styles.statLabel}>Total Positions</div>
            </div>
            <div className={styles.statCard}>
              <div className={styles.statNumber}>{data?.budget_cost || "N/A"}</div>
              <div className={styles.statLabel}>Project Budget</div>
            </div>
          </div>
        </div>

        <Box maxWidth="1200px" mx="auto">
          <Card className={styles.projectCard} sx={{ mb: 4 }}>
            <CardContent>
              <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: "#1e293b" }}>
                {data?.project_name}
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={12} md={8}>
                  <Typography variant="body1" sx={{ mb: 2, color: "#64748b" }}>
                    <strong>Project Tags:</strong>
                  </Typography>
                  <div className={styles.chipContainer}>
                    {data?.tags?.split(",").map((tag: string, i: number) => (
                      <Chip key={i} label={tag.trim()} className={styles.modernChip} size="medium" />
                    ))}
                  </div>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Stack spacing={2}>
                    <Box>
                      <Typography variant="body2" color="textSecondary">
                        Budget Allocation
                      </Typography>
                      <Typography variant="h6" sx={{ fontWeight: 600, color: "#059669" }}>
                        {data?.budget_cost || "N/A"}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography variant="body2" color="textSecondary">
                        Team Size Needed
                      </Typography>
                      <Typography variant="h6" sx={{ fontWeight: 600, color: "#4f46e5" }}>
                        {data?.project || "N/A"} person(s)
                      </Typography>
                    </Box>
                  </Stack>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card className={styles.projectCard}>
            <CardContent>
              <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
                <Typography variant="h5" className={styles.sectionTitle}>
                  Job Roles Overview
                </Typography>
                <Button className={styles.addButton} onClick={() => setOpenAddModal(true)} startIcon={<span>+</span>}>
                  Add New Role
                </Button>
              </Stack>

              <Paper className={styles.modernTable}>
                <Table>
                  <TableHead className={styles.tableHeader}>
                    <TableRow>
                      <TableCell className={styles.tableHeaderCell}>Job Title</TableCell>
                      <TableCell className={styles.tableHeaderCell}>Budget</TableCell>
                      <TableCell className={styles.tableHeaderCell}>Positions</TableCell>
                      <TableCell className={styles.tableHeaderCell}>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {customRoles.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={4} className={styles.emptyState}>
                          <div className={styles.emptyStateIcon}>📋</div>
                          <Typography variant="h6" gutterBottom>
                            No job roles created yet
                          </Typography>
                          <Typography variant="body2">
                            Start by adding your first job role to begin recruiting
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ) : (
                      customRoles.map((role, index) => (
                        <TableRow key={index} className={styles.tableRow}>
                          <TableCell className={styles.tableCell}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                              {role.job_title}
                            </Typography>
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            <Typography variant="body1" sx={{ color: "#059669", fontWeight: 500 }}>
                              {role.budget}
                            </Typography>
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            <Chip
                              label={`${role.number_required} needed`}
                              size="small"
                              sx={{
                                background: "#eff6ff",
                                color: "#1d4ed8",
                                fontWeight: 500,
                              }}
                            />
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            <Button className={styles.actionButton} size="small" onClick={() => handleView(role)}>
                              View Details
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </Paper>
            </CardContent>
          </Card>
        </Box>

        <Dialog
          open={openViewModal}
          onClose={() => setOpenViewModal(false)}
          fullWidth
          maxWidth="md"
          PaperProps={{
            sx: { borderRadius: "16px", overflow: "hidden" },
          }}
        >
          <DialogTitle className={styles.modalTitle}>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              Role Details
            </Typography>
          </DialogTitle>
          <DialogContent className={styles.modalContent} dividers>
            {selectedRole && (
              <Grid container spacing={3}>
                {Object.entries(selectedRole).map(([key, value]) => (
                  <Grid item xs={12} sm={6} key={key}>
                    <Card sx={{ p: 2, background: "white", borderRadius: "12px" }}>
                      <Typography
                        variant="caption"
                        color="textSecondary"
                        sx={{ textTransform: "uppercase", letterSpacing: "0.05em" }}
                      >
                        {key.replace(/([A-Z])/g, " $1").replace(/_/g, " ")}
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: 500, mt: 0.5 }}>
                        {value || "Not specified"}
                      </Typography>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            )}
          </DialogContent>
          <DialogActions sx={{ p: 3 }}>
            <Button onClick={() => setOpenViewModal(false)} className={styles.actionButton}>
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openAddModal}
          onClose={() => setOpenAddModal(false)}
          fullWidth
          maxWidth="lg"
          PaperProps={{
            sx: { borderRadius: "16px", overflow: "hidden" },
          }}
        >
          <DialogTitle className={styles.modalTitle}>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              Create New Job Role
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.9, mt: 1 }}>
              Define the requirements and specifications for this position
            </Typography>
          </DialogTitle>
          <DialogContent className={styles.modalContent} dividers sx={{ maxHeight: "70vh", overflowY: "auto" }}>
            <Stack spacing={2} mt={1}>
              {/* Basic Information */}
              <Accordion defaultExpanded className={styles.modernAccordion}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} className={styles.accordionSummary}>
                  <Typography className={styles.accordionTitle}>Basic Information *</Typography>
                </AccordionSummary>
                <AccordionDetails className={styles.accordionDetails}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Job Title *"
                        fullWidth
                        size="small"
                        value={newJobTitle}
                        onChange={(e) => setNewJobTitle(e.target.value)}
                        required
                        className={styles.formField}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Budget *"
                        fullWidth
                        size="small"
                        value={newBudget}
                        onChange={(e) => setNewBudget(e.target.value)}
                        placeholder="e.g., ₦500,000"
                        required
                        className={styles.formField}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Number of People Required*"
                        fullWidth
                        size="small"
                        type="number"
                        value={newNumberOfPeople}
                        onChange={(e) => setNewNumberOfPeople(e.target.value)}
                        required
                        className={styles.formField}
                      />
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              {/* Location & Work Preferences */}
              <Accordion className={styles.modernAccordion}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} className={styles.accordionSummary}>
                  <Typography className={styles.accordionTitle}>Location & Work Preferences</Typography>
                </AccordionSummary>
                <AccordionDetails className={styles.accordionDetails}>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        label="Location"
                        fullWidth
                        size="small"
                        value={location}
                        onChange={(e) => setLocation(e.target.value)}
                        placeholder="e.g., Lekki, Lagos, Lagos State, Nigeria"
                        className={styles.formField}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth size="small" className={styles.formField}>
                        <InputLabel>Willing to Relocate</InputLabel>
                        <Select value={willingToRelocate} onChange={(e) => setWillingToRelocate(e.target.value)}>
                          <MenuItem value="Yes">Yes</MenuItem>
                          <MenuItem value="No">No</MenuItem>
                          <MenuItem value="Maybe">Maybe</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth size="small" className={styles.formField}>
                        <InputLabel>Remote Work Preference</InputLabel>
                        <Select value={remoteWorkPreference} onChange={(e) => setRemoteWorkPreference(e.target.value)}>
                          <MenuItem value="Yes">Yes</MenuItem>
                          <MenuItem value="No">No</MenuItem>
                          <MenuItem value="Hybrid">Hybrid</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth size="small" className={styles.formField}>
                        <InputLabel>Employment Type</InputLabel>
                        <Select
                          multiple
                          value={employmentType}
                          onChange={handleEmploymentTypeChange}
                          renderValue={(selected) => (
                            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                              {selected.map((value: string) => (
                                <Chip key={value} label={value} size="small" />
                              ))}
                            </Box>
                          )}
                        >
                          <MenuItem value="Full-Time">Full-Time</MenuItem>
                          <MenuItem value="Part-Time">Part-Time</MenuItem>
                          <MenuItem value="Contract">Contract</MenuItem>
                          <MenuItem value="Freelance">Freelance</MenuItem>
                          <MenuItem value="Internship">Internship</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth size="small" className={styles.formField}>
                        <InputLabel>Availability</InputLabel>
                        <Select value={availability} onChange={(e) => setAvailability(e.target.value)}>
                          <MenuItem value="Immediately Available">Immediately Available</MenuItem>
                          <MenuItem value="2 weeks notice">2 weeks notice</MenuItem>
                          <MenuItem value="1 month notice">1 month notice</MenuItem>
                          <MenuItem value="2+ months notice">2+ months notice</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              {/* ... existing code for other accordion sections ... */}
              {/* Personal Information */}
              <Accordion className={styles.modernAccordion}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} className={styles.accordionSummary}>
                  <Typography className={styles.accordionTitle}>Personal Information</Typography>
                </AccordionSummary>
                <AccordionDetails className={styles.accordionDetails}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Nationality"
                        fullWidth
                        size="small"
                        value={nationality}
                        onChange={(e) => setNationality(e.target.value)}
                        placeholder="e.g., Nigerian"
                        className={styles.formField}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Work Authorization"
                        fullWidth
                        size="small"
                        value={workAuthorization}
                        onChange={(e) => setWorkAuthorization(e.target.value)}
                        placeholder="e.g., Eligible to work in Nigeria"
                        className={styles.formField}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        label="Minimum Age"
                        fullWidth
                        size="small"
                        type="number"
                        value={minAge}
                        onChange={(e) => setMinAge(e.target.value)}
                        className={styles.formField}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        label="Maximum Age"
                        fullWidth
                        size="small"
                        type="number"
                        value={maxAge}
                        onChange={(e) => setMaxAge(e.target.value)}
                        className={styles.formField}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControl fullWidth size="small" className={styles.formField}>
                        <InputLabel>Gender</InputLabel>
                        <Select value={gender} onChange={(e) => setGender(e.target.value)}>
                          <MenuItem value="Male">Male</MenuItem>
                          <MenuItem value="Female">Female</MenuItem>
                          <MenuItem value="Any">Any</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Languages Spoken"
                        fullWidth
                        size="small"
                        value={languagesSpoken}
                        onChange={(e) => setLanguagesSpoken(e.target.value)}
                        placeholder="e.g., English, Yoruba, Hausa"
                        className={styles.formField}
                      />
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              {/* Education */}
              <Accordion className={styles.modernAccordion}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} className={styles.accordionSummary}>
                  <Typography className={styles.accordionTitle}>Education Requirements</Typography>
                </AccordionSummary>
                <AccordionDetails className={styles.accordionDetails}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth size="small" className={styles.formField}>
                        <InputLabel>Level of Education</InputLabel>
                        <Select value={levelOfEducation} onChange={(e) => setLevelOfEducation(e.target.value)}>
                          <MenuItem value="High School">High School</MenuItem>
                          <MenuItem value="Diploma">Diploma</MenuItem>
                          <MenuItem value="BSc">BSc</MenuItem>
                          <MenuItem value="MSc">MSc</MenuItem>
                          <MenuItem value="PhD">PhD</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Field of Study"
                        fullWidth
                        size="small"
                        value={fieldOfStudy}
                        onChange={(e) => setFieldOfStudy(e.target.value)}
                        placeholder="e.g., Computer Science"
                        className={styles.formField}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Certificate/Qualification"
                        fullWidth
                        size="small"
                        value={certificateQualification}
                        onChange={(e) => setCertificateQualification(e.target.value)}
                        placeholder="e.g., PMP, HSE Level 1, AWS Certified"
                        className={styles.formField}
                      />
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              {/* Experience & Skills */}
              <Accordion className={styles.modernAccordion}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} className={styles.accordionSummary}>
                  <Typography className={styles.accordionTitle}>Experience & Skills</Typography>
                </AccordionSummary>
                <AccordionDetails className={styles.accordionDetails}>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        label="Required Skills"
                        fullWidth
                        size="small"
                        multiline
                        rows={3}
                        value={skills}
                        onChange={(e) => setSkills(e.target.value)}
                        placeholder="e.g., PHP, Laravel, JavaScript, SQL, Git"
                        className={styles.formField}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Previous Industries"
                        fullWidth
                        size="small"
                        value={previousIndustries}
                        onChange={(e) => setPreviousIndustries(e.target.value)}
                        placeholder="e.g., FinTech, eCommerce, Education"
                        className={styles.formField}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Total Years of Experience"
                        fullWidth
                        size="small"
                        type="number"
                        value={totalYearOfExperience}
                        onChange={(e) => setTotalYearOfExperience(e.target.value)}
                        className={styles.formField}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Job Function"
                        fullWidth
                        size="small"
                        multiline
                        rows={2}
                        value={jobFunction}
                        onChange={(e) => setJobFunction(e.target.value)}
                        placeholder="e.g., Backend development, API integration, DevOps"
                        className={styles.formField}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Preferred Industries"
                        fullWidth
                        size="small"
                        value={preferredIndustries}
                        onChange={(e) => setPreferredIndustries(e.target.value)}
                        placeholder="e.g., FinTech, HealthTech"
                        className={styles.formField}
                      />
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              {/* Salary Expectations */}
              <Accordion className={styles.modernAccordion}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} className={styles.accordionSummary}>
                  <Typography className={styles.accordionTitle}>Salary Expectations</Typography>
                </AccordionSummary>
                <AccordionDetails className={styles.accordionDetails}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Minimum Salary"
                        fullWidth
                        size="small"
                        type="number"
                        value={minSalary}
                        onChange={(e) => setMinSalary(e.target.value)}
                        placeholder="300000"
                        className={styles.formField}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Maximum Salary"
                        fullWidth
                        size="small"
                        type="number"
                        value={maxSalary}
                        onChange={(e) => setMaxSalary(e.target.value)}
                        placeholder="500000"
                        className={styles.formField}
                      />
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Stack>
          </DialogContent>
          <DialogActions sx={{ p: 3, background: "white" }}>
            <Button onClick={() => setOpenAddModal(false)} sx={{ mr: 1 }}>
              Cancel
            </Button>
            <Button onClick={resetForm} color="secondary" sx={{ mr: 1 }}>
              Reset Form
            </Button>
            <Button variant="contained" onClick={handleAddNewRole} className={styles.addButton}>
              Create Job Role
            </Button>
          </DialogActions>
        </Dialog>
      </IonContent>
    </IonPage>
  )
}

export default JobSetUpProjectDetail
